import React, {useState, useEffect} from 'react';
import Header from '../components/Header'; // adjust path if needed
import Get from '../components/Get'; // adjust path if needed

const Page = () => {
  const [data, setData] = useState('');
  const [id, setId] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await Get.Page();
        if (res.data) {
          setData(res.data.description);
        }
      } catch (err) {
        console.error('Failed to fetch page:', err);
      }
    };

    fetchPage();

    // Get OTP from localStorage
    const otp = localStorage.getItem('otp');
    if (otp) {
      try {
        const parsed = JSON.parse(otp);
        setId(parsed.data);
      } catch (e) {
        console.error('Invalid OTP in localStorage', e);
      }
    }
  }, []);

  return (
    <>
      <Header />
      <div style={styles.card}>
        {data ? (
          <div
            style={styles.htmlContent}
            dangerouslySetInnerHTML={{__html: data}}
          />
        ) : (
          <p style={styles.loading}>Loading...</p>
        )}
      </div>
    </>
  );
};

export default Page;

const styles = {
  card: {
    width: '90%',
    minHeight: '90vh',
    borderRadius: '16px',
    padding: '20px',
    backgroundColor: 'white',
    boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
    margin: '20px auto',
    overflowY: 'auto',
  },
  htmlContent: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: '#333',
    lineHeight: '1.6',
  },
  loading: {
    textAlign: 'center',
    fontSize: '18px',
    color: '#555',
  },
};
